import React, { useState } from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { CgMenu } from "react-icons/cg"
import NavOptions from "./NavOptions"
import Button from "./Button"

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false)

  let menuOverlay

  if (showMenu) {
    menuOverlay = (
      <MenuOverlay
        onClick={() => {
          setShowMenu(false)
        }}
      />
    )
  }

  return (
    <Container>
      <Link to="/">
        <StaticImage
          src="../images/finnick-logo-full.svg"
          alt=""
          quality="100"
        />
      </Link>
      <MenuBars onClick={() => setShowMenu(!showMenu)} />
      <NavMenu showMenu={showMenu}>
        <NavOptions />
        <ButtonContainer>
          <div style={{ marginBottom: "2vh" }}>
            <Link to="/login">
              <Button text="Sign in" large />
            </Link>
          </div>
          <Link to="/register">
            <Button text="Sign up" primary large />
          </Link>
        </ButtonContainer>
      </NavMenu>
      <NavLinkContainer>
        <NavOptions />
      </NavLinkContainer>
      {menuOverlay}
    </Container>
  )
}

export default Navbar

const MenuOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.2);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 998;

  @media screen and (min-width: 768px) {
    display: none;
  }
`

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem calc((100vw - 1200px) / 2);
`

const MenuBars = styled(CgMenu)`
  font-size: 2rem;
  cursor: pointer;

  @media screen and (min-width: 768px) {
    display: none;
  }
`

const NavMenu = styled.div`
  position: absolute;
  top: 10vh;
  right: 3vw;
  width: 300px;
  z-index: 999;
  background: #fff;
  box-shadow: rgba(73, 73, 73, 0.5) 0px 8px 24px;
  border-radius: 5px;

  display: ${props => (props.showMenu ? "inline" : "none")};

  @media screen and (min-width: 768px) {
    display: none;
  }
`

const ButtonContainer = styled.div`
  margin-bottom: 5vh;
  text-align: center;
`

const NavLinkContainer = styled.nav`
  display: flex;

  @media screen and (max-width: 768px) {
    display: none;
  }
`
